import DriverApp from "@/pages/driver/Index.vue"

const driverRoutes = [
  {
    path: "/",
    component: DriverApp,
  },
]

export default driverRoutes